import { useFeatureFlags } from '@previo/feature-flags'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { usePreferredPMSVersion } from '~/composables/usePreferredPMSVersion'
import { usePmsVersionOverride } from '~/composables/usePmsVersionOverride'

const checkPreferredVersion = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (import.meta.env.PMS_FE_ROUTER_PREFERENCE_ENABLED !== 'true') {
    return next()
  }

  const ff = useFeatureFlags()
  await ff.waitForInit()

  if (usePmsVersionOverride().isForced.value) {
    return next()
  }

  if (!usePreferredPMSVersion().usesCurrent()) {
    return next()
  }

  return next({
    name: to.meta.P1Route,
    params: to.params,
    query: to.query,
  })
}

export default checkPreferredVersion
